import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {useCallback} from 'react';
import {useSessionGender} from '../../../shared-deprecated/sessionGender';

export const useGetGenderBanner = () => {
  const {gender} = useSessionGender();

  return useCallback(
    (activeDiscount: GetDiscountsResponse_Discount) => {
      if (!activeDiscount) {
        return;
      }

      switch (gender) {
        case 'male':
          return activeDiscount.maleTopBanner;
        default:
          return activeDiscount.femaleTopBanner;
      }
    },
    [gender],
  );
};
